<template>
  <div>
    <PageHeader icon="pending_actions" :title="fileName" no-padding>
      <template v-if="show" v-slot:subtitle>
        <v-divider />
        <v-card dark>
          <StatusChip :icon="reviewStatus.icon" :icon-color="reviewStatus.color" title="Ingestion Outcome" :text="reviewStatus.text" />
          <StatusChip title="Ingestion Date" :text="ingestionDate" />
          <ExecutionFileVersionChip @click:version="() => this.$router.push($event.to)" :fileVersions="fileVersions" :isLatestVersion="executionResults.IsLatestVersion" />

          <!-- <StatusChip title="File Version" :closeOnContentClick="false" :text="versionStatus">
            <template #actions>
              <v-list-tile v-for="(version, index) in fileVersions" :class="{ 'card-bg-2': version.isCurrent }" :inactive="version.isCurrent" :key="index" :to="version.to">
                <v-list-tile-avatar>
                  <v-tooltip v-if="version.isIngested" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" :color="version.hasIngestionError ? 'error' : 'info'" v-html="version.hasIngestionError ? 'cloud_off' : 'cloud_done'" />
                    </template>
                    <span v-if="version.hasIngestionError">This data file could not be ingested.</span>
                    <span v-else>This data file was ingested successfully.</span>
                  </v-tooltip>
                </v-list-tile-avatar>
                <v-list-tile-title class="clickable">
                  {{ version.versionDate }}
                  <span class="info--text pl-1" v-if="version.isCurrent">(current)</span>
                  <span class="pl-1" v-else-if="index == 0">(latest)</span>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </StatusChip> -->
        </v-card>
        <v-card dark>
          <StatusChip v-if="states.hasJustResubmitted" icon="info" icon-color="success lighten-2" title="Review status" text="Ingested successfully" />
          <StatusChip v-else-if="states.canResubmit" icon="info" icon-color="info lighten-2" title="Review status" :text="hasBeenIngested ? 'No errors &ndash; ready for reingestion' : 'Ready for ingestion'" />
          <StatusChip v-else icon="error" icon-color="error lighten-2" title="Review status" text="Must checkout all errors" />
        </v-card>
      </template>
    </PageHeader>
    <v-card v-if="show">
      <v-card-actions class="card-bg-2 py-0 layout wrap">
        <UpdateAndIngestExecutionResults #default="{ submit, loading }">
          <PrimaryBtn v-if="isTenantAdmin" @submit:success="onIngestSuccess()" @click="submit(fileId)" icon="publish" :loading="loading" :disabled="states.canResubmit || !executionResults.IsLatestVersion" class="my-2 ml-0 mr-2" style="min-width: 160px">
            {{ hasBeenIngested ? 'Reingest' : 'Ingest' }}
          </PrimaryBtn>
        </UpdateAndIngestExecutionResults>

        <SecondaryBtn :to="{ name: 'dataset', params: { id: fileId } }" icon="description" class="my-2 ml-0 mr-2" style="min-width: 160px">
          View file details
        </SecondaryBtn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  import { prettyDateTimeFormat } from '@/components/mixins/MomentUtil'
  import moment from 'moment'

  import { createNamespacedHelpers } from 'vuex'
  const reviewIngestionResults = createNamespacedHelpers('reviewingestionresults')
  const authenticate = createNamespacedHelpers('authenticate')

  import UpdateAndIngestExecutionResults from './Review/Actions/UpdateAndIngestExecutionResults'

  export default {
    components: {
      UpdateAndIngestExecutionResults,
    },
    props: {
      viewer: Object,
    },
    data: () => ({
      loading: {},
    }),
    computed: {
      ...reviewIngestionResults.mapState(['fileDetails', 'executionResults', 'states']),
      ...authenticate.mapGetters(['isTenantAdmin']),
      show() {
        return !this.states.loadingResults && !this.states.errorResults
      },
      fileName() {
        return this.states.loadingResults ? '' : (this.fileDetails && this.fileDetails.name || 'No results found')
      },
      fileId() {
        return this.fileDetails && this.fileDetails.id || 0
      },
      hasBeenIngested() {
          //return this.fileDetails && this.fileDetails.ingestionDate
        return this.executionResults.IsSuccess
      },
      reviewStatus() {
        if (!this.executionResults) return {
          text: 'Pending',
          icon: 'pending_actions',
          color: 'warning',
        }

        let rollbackDate = this.executionResults.RollbackDate

        if (this.executionResults.IsSuccess) {
          if (this.executionResults.IsLatestVersion && !rollbackDate) return {
            text: 'Successfully ingested',
            icon: 'done',
            color: 'success', 
          }
          else if (rollbackDate) return {
            text: `Successfully ingested, but was rolled back on ${moment(rollbackDate).format(prettyDateTimeFormat)}`,
            icon: 'warning',
            color: 'warning',
          }
          else return {
            text: 'Successfully ingested, but a newer version exists.',
            icon: 'warning',
            color: 'warning',
          }
        }

        if (this.executionResults.IsLatestVersion) return {
          text: 'Failed to ingest data. Please check out errors and resubmit.',
          icon: 'error',
          color: 'error',
        }
        else return {
          text: 'Failed to ingest data, but a newer version exists.',
          icon: 'warning',
          color: 'warning',
        }

      },
      parentVersion() {
        return this.executionResults && this.executionResults.ParentVersionFileId
      },
      fileVersions() {
        if (!this.fileDetails) return []
        return this.fileDetails.newFileVersions.map(version => ({
          ...version,
          to: version.executionId && {
            name: 'reviewingestionresults',
            params: { executionId: version.executionId },
          },
        }))
      },
      ingestionDate() {
        return this.fileDetails && this.fileDetails.ingestionDate && moment(this.fileDetails.ingestionDate).format(prettyDateTimeFormat) || 'n/a'
      },
    },
    methods: {
      ...reviewIngestionResults.mapActions(['resubmitData', 'updateStates']),
      onIngestSuccess() {
        this.updateStates({ hasJustResubmitted: true })
        this.$emit('refresh')
      },
    },
  }
</script>